import React from "react";

const FormField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  required = false,
  error = null,
  placeholder = "",
  className = "",
  children,
  ...props
}) => {
  const baseInputClasses = `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${className}`;
  const errorClasses = error ? "border-red-300 bg-red-50" : "border-gray-300";
  const inputClasses = `${baseInputClasses} ${errorClasses}`;

  const handleChange = (e) => {
    const newValue = type === "checkbox" ? e.target.checked : e.target.value;
    onChange(name, newValue);
  };

  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {children ? (
        // Custom input (like select, textarea)
        React.cloneElement(children, {
          className: inputClasses,
          value,
          onChange: handleChange,
          ...props,
        })
      ) : (
        // Standard input
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className={inputClasses}
          required={required}
          {...props}
        />
      )}

      {error && (
        <div className="text-sm text-red-600 mt-1">
          {Array.isArray(error) ? (
            <ul className="list-disc list-inside space-y-1">
              {error.map((err, index) => (
                <li key={index}>{err}</li>
              ))}
            </ul>
          ) : (
            <p>{error}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FormField;
